import { Vue, Component, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class Blank extends Vue {
  @Prop({ default: () => {} })
    value: DisplayBlankData | NewDisplayShopBlank;

  render(h) {
    return <div style={`height: ${this.value.desc.bHeight / 2}px`}></div>;
  }
}
